var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxCheckedIcon = function SvgCheckboxCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#C92A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.432 6.004a.5.5 0 0 0-.291.151c-1.667 1.67-2.915 3.05-4.506 4.662l-1.81-1.53a.5.5 0 1 0-.646.765l2.165 1.832a.5.5 0 0 0 .676-.032c1.786-1.79 3.063-3.225 4.828-4.995a.5.5 0 0 0-.416-.853Z",
    fill: "#F8F9FA"
  })));
};
export default SvgCheckboxCheckedIcon;